import { useParams } from 'react-router-dom';
import EventDetail from './EventDetail';

export default function EventLandingPage() {
  const { eventId } = useParams();

  if (!eventId) return null;

  return (
    <div className="relative min-h-full overflow-hidden">
      <div className="pointer-events-none absolute -top-24 -left-20 w-[420px] h-[420px] rounded-full blur-[110px] opacity-30 immersive-glow-accent" />
      <div className="pointer-events-none absolute top-1/4 -right-24 w-[460px] h-[460px] rounded-full blur-[120px] opacity-25 immersive-glow-accent-deep" />
      <div className="pointer-events-none absolute -bottom-28 left-1/4 w-[380px] h-[380px] rounded-full blur-[100px] opacity-25 immersive-glow-accent-darker" />

      <div className="relative z-10 max-w-4xl mx-auto px-3 sm:px-4 py-4 sm:py-6">
        <div className="modal-glass-surface rounded-xl shadow-2xl overflow-hidden">
          <EventDetail eventId={eventId} />
        </div>
      </div>
    </div>
  );
}
